/**
 * This component renders a mini news item preview on the home page
 */
import React from "react";
import { Link } from "react-router-dom";
import ImageContainer from "../core/ImageContainer";

const MiniNewsItem = ({ time, author, newsId, filename, title, last, type, url_override, extra_classes }) => {
    return (
      <Link
        to={url_override ? url_override : `/news/${newsId}`}
        className={`group pb-2 xl:w-1/3 sm:w-3/6 xxs:max-sm:pb-2 w-full flex flex-row items-start justify-start sm:mx-2 max-h-32 ` + extra_classes}
        target={url_override ? "_blank" : ""}
      >
        {/* Image Container */}
        <div className="xs:h-[100px] xs:w-[160px] xs:min-h-[100px] xs:max-h-[100px] xs:min-w-[160px] xs:max-w-[160px] min-w-[120px] h-[80px]">
          <ImageContainer src={filename} alt={title} />
        </div>
  
        {/* Text Container */}
        <div className="pl-3 w-auto">
          {/* Title with color change on hover */}
          <h2 className="text2l drop-shadow max-xs:text-lg mb-0.5 sm:text-sm md:text-smm lg:text-xl xs:text-xl font-medium leading-tight transition-colors ease-out duration-300 group-hover:text-buiha-red dark:group-hover:text-dark-5">
            {title}
          </h2>
  
          {/* Subtext */}
          <p className="text-darken text-xs drop-shadow block font-light">
            {type === "news" ? `${time} ago` : `Posted ${time} ago`}
          </p>
        </div>
      </Link>
    );
  };
  
  export default MiniNewsItem;